import PropTypes from "prop-types";
import styles from "./SearchBoxContainer.module.scss";
import Image from "../../atoms/image/image";
import { connect, CustomContainer } from "../../atoms/DependencyHelper";
import config from "../../../config/index";
import React, { useEffect,useState } from "react";

const SearchBoxContainer = ({
	closeRequired = true,
	className,
	text,
	handleChange,
	handleCancel,
	hideNavItems,
	inputStyle,
	handleKeyPress,
	handleSearchClick,
	handleFocus,
	isSearchTxt,
	isSearchComb,
	focus,
	placeholder = "",
	HintBlock = null,
	iconStyle,
}) => {
	const env = config.env;
	const imagePrefix = config.envConfigs[env].imagePrefix;
	const inputAutoFocus = React.createRef();
	const [searchText, setSearchText] = useState('');
	const [blur, markAsBlurred] = useState(false);

	useEffect(() => {
		if(focus) {
			inputAutoFocus.current.focus();
		}
	 },[focus])

	 useEffect(() => {
		 setSearchText(text)
	 },[text])

	const handleOnChange = (e)=>{
		if(isSearchTxt){
			setSearchText(e.target.value);
		}else if (isSearchComb){
		  setSearchText(e.target.value);
			handleChange(e);
		} else {
		  handleChange(e);
		}
	}

	const handleInputFocus = () => {
		handleFocus && handleFocus();
		markAsBlurred(false);
	}

	const setImgPath = () => {
		let iconPath = `${imagePrefix}/assets/images/search`;
		if (iconStyle) {
		  iconPath += `-${iconStyle}`;
		} else {
				if (HintBlock) {
    			iconPath += '-blue';
    		} else if (hideNavItems) {
    			iconPath += '-red';
    		}
		}
		return iconPath += '.svg';
	}

  const resetValue = () => {
     setSearchText("");
     handleCancel();
  }

	return (
		<>
			<CustomContainer className={`${styles["search-box"]} ${HintBlock && searchText && !blur && styles["focus"]} ${className}`}>
				<Image
					className={styles.img}
					img_path={setImgPath()}
					img_alt="icon"
					img_width="1.125rem"
					img_height="1.125rem"
					onClick={handleSearchClick}
					id="search-box-img"
				/>
				<input
					ref={inputAutoFocus}
					type="text"
					name={searchText}
					onBlur={() => markAsBlurred(true)}
					className={`${styles["search-input"]} ${inputStyle}`}
					onChange={handleOnChange}
					value={searchText}
					//onChange= isSearch ?     {e => setSearchText(e.target.value)}
					onKeyPress={handleKeyPress}
					onFocus={handleInputFocus}
					id="search-box-input"
					placeholder={placeholder}
				/>
				{searchText && (
					<Image
						className={styles.img}
						img_path={`${imagePrefix}/assets/images/close-copy.svg`}
						img_alt="icon"
						img_width="1.125rem"
						img_height="1.125rem"
						onClick={resetValue}
					/>
				)}
			</CustomContainer>
			{HintBlock && searchText && !blur && <HintBlock addClass={styles["hintBlock-box"]} />}
		</>
	);
};

const mapStateToProps = (state) => ({
	hideNavItems: state.navDetails.hideNavItems,
});

export default connect(mapStateToProps)(SearchBoxContainer);
